import React from "react";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { useTenantParams } from "../../../../customhooks/tenantparamlookup"; //CustomHook
import { Grid } from "@material-ui/core";
import { useTheme } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";
export default function ChartTest(props) {
  const theme = useTheme();
  const propsApiData = props?.data;

  //Using useTenantParams Custom Hook........................
  let [chartypes] = useTenantParams(["USAGE_CHART_TYPE"]);
  let [appColor] = useTenantParams(
    [
      "PRIMARY_COLOR",
      "SECONDARY_COLOR",
      "TERTIARY_COLOR",
      "QUATERNARY_COLOR",
      "QUINARY_COLOR",
    ],
    {}
  );
  const {t:Labels, ready: labelReady} = useTranslation("label-HIGHEST_USAGE");
  const [dataChart, setDataChart] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const [stacked, setStacked] = useState(false); //Stacked True means we will get Stacked Chart,if False we will get Bar chart
  useEffect(() => {
    const chartDataset = {
      fill: true,
      lineTension: 0.6,
      type: chartypes[0],
      borderColor: theme.palette.ePrimary?.base,
      borderWidth: 1,
      borderPercentage: 0.1,
      datasets: [
        {
          label: props.units,
          yAxisID: "kWh",
          data: propsApiData?.graphQuantity,
          noData:propsApiData?.noDataDaily,
          backgroundColor: props.billView ? theme.palette.eSecondary?.base : theme.palette.eTertiary?.base,
          barPercentage: 0.6,
          borderRadius: {
            topLeft: 100,
            topRight: 100
          },
        },
        {
          label: "Taka",
          yAxisID: "Taka",
          data:propsApiData?.graphAmount,
          backgroundColor: theme.palette.eSecondary?.base,
          barPercentage: 0.6,
          borderRadius: {
            topLeft: 100,
            topRight: 100
          },
        },
      ],
      order: 1,
      labels: propsApiData?.graphLabels,     
    };

    setDataChart({
      datasets: chartDataset,
    });
    setChartOptions(getChartOptions());
  }, [props.data, appColor]);

  const getTitles = () => {
    return {
      display: false,
      text: props.labelReady ? props.labels("USAGE_ELECTRICITY_USAGE_TITLE") : '',
      fontSize: 20,
    }
  }

  const getToolTip = () => {
    return {
      enabled: true,
      usePointStyle: true,
      position: "average",
      mode: "nearest",
      intersect: false,
      backgroundColor: theme.palette.whiteColor.main,
      bodyColor: theme.palette.eDark?.base,
      bodyFontColor: theme.palette.eDark?.base,
      padding: 10,
      borderColor: theme.palette.eLight?.base,
      borderWidth: 1,
      cornerRadius: 2,
      boxWidth: 6,
      boxHeight: 6,
      callbacks: {
        title: () => null,
        label: function (context, value) {
          if (context.dataset.label === "kWh") {
            return [context.label, context.parsed.y + ' ' + props.units]
          }
          return [context.label, "৳"+ context.parsed.y]
          var label = "";
          if(context.dataset.noData[context.dataIndex] === "true"){
            label=Labels("E_NO_DATA")
          }else{
            label = `${Math.round(context.parsed.y)+ ' ' + props.units}`
          }
          return [context.label, label ]
        }
      },
      displayColors: true,
    }
  }

  const getChartOptions = () => {
    return {
      title: getTitles(),
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
          position: "top",
          labels: {
            usePointStyle: true,
            boxWidth: 5,
            color: theme.palette.ePrimary?.base
          },
        },
        tooltip: getToolTip(),
      },
      scales: {
        x:
        {
          stacked: stacked,
          display: true,
          ticks: {
            color: theme.palette.ePrimary?.base,
          },
          grid: {
            display: false,
          },
          categoryPercentage: 0.4,
          barPercentage: 0.4
        },
        kWh:
        {
          position:"left",
          stacked: stacked,
          grid: {
            display: true,
            drawBorder: false
          },
          ticks: {
            beginAtZero: true,
            color: theme.palette.eTertiary?.base,
            callback: function (value, index, values) {
              return value + ' ' + props.units;
            },
          },
        },
        Taka: {
          position:"right",
          stacked: stacked,
          grid: {
            display: false,
            drawBorder: false
          },
          ticks: {
            beginAtZero: true,
            color: theme.palette.eSecondary?.base,
            callback: function (value, index, ticks) {
              return '৳'+ value;
            },
          },
        },
      },
    }
  }

  const datasetKeyProvider = () => {
    return btoa(Math.random()).substring(0, 12);
  };
  return (
    <Grid >
      {dataChart?.datasets ?
        <>
          <Bar
            height={props.height}
            width={props.width}
            data={dataChart?.datasets}
            options={chartOptions}
            datasetKeyProvider={datasetKeyProvider}
            
          />
        </>
        : null}
    </Grid>
  );
}